import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	callToAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	engageMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headLine: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	learnMoreMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	callToActionIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	callToAction: {
		id: 'compass-cross-flow.call-to-action',
		defaultMessage:
			'Create a comprehensive catalog of software components in Compass, then link them to issues – so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward.',
		description: 'This text is displayed in a section message as a call to action for the user.',
	},
	engageMessage: {
		id: 'compass-cross-flow.engage-message',
		defaultMessage: 'Try Compass free',
		description: 'This text informs users that they can click this link to get Compass for free.',
	},
	headLine: {
		id: 'compass-cross-flow.head-line',
		defaultMessage: 'A new way to work on software components ',
		description: "This text is the bold headline that is to attract the user's attention",
	},
	learnMoreMessage: {
		id: 'compass-cross-flow.learn-more-message',
		defaultMessage: 'Learn more about Compass',
		description:
			'This text informs users that they can click this link to learn more about Compass.',
	},
	callToActionIssueTermRefresh: {
		id: 'compass-cross-flow.call-to-action-issue-term-refresh',
		defaultMessage:
			'Create a comprehensive catalog of software components in Compass, then link them to work items – so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward.',
		description: 'This text is displayed in a section message as a call to action for the user.',
	},
});
export default messages;
